import { XeoFeaturePlanEnum } from './xeo-feature-plan.enum';

export interface XeoFeaturePlanContent {
  name: XeoFeaturePlanEnum;
  priceMonthly: number | null;
  priceYearly: number | null;
  features: string[];
}

export const xeoFeaturePlansContent: XeoFeaturePlanContent[] = [
  {
    name: XeoFeaturePlanEnum.XEO_STARTER,
    priceMonthly: 0,
    priceYearly: 0,
    features: [
      '100 MB project & file size limit',
      '2 files per project',
      'Public sharing',
      'Embed models via iFrame',
      'Project retention after last access: 1 month',
    ],
  },
  // {
  //   name: XeoFeaturePlanEnum.XEO_ESSENTIALS,
  //   priceMonthly: 50,
  //   priceYearly: 41.67,
  //   features: [
  //     'All from xeoStarter',
  //     '250 MB project & file size limit',
  //     '5 files per project',
  //     'Private sharing',
  //     'Export BIM metadata to CSV/Excel',
  //     'Project retention after last access: 1 year',
  //   ],
  // },
  // {
  //   name: XeoFeaturePlanEnum.XEO_PRIORITY,
  //   priceMonthly: 100,
  //   priceYearly: 83.33,
  //   features: [
  //     'All xeoEssentials',
  //     '1.5 GB project & 1 GB file size limit',
  //     '10 files per project',
  //     'High-priority server processing',
  //     'Premium technical support',
  //     'Project retention after last access: unlimited',
  //   ],
  // },
  {
    name: XeoFeaturePlanEnum.XEO_INTEGRATOR,
    priceMonthly: null,
    priceYearly: null,
    features: ['All from xeoPriority', 'Access to xeokit Service Desk', 'Access to xeokit Roadmap'],
  },
  {
    name: XeoFeaturePlanEnum.XEO_ENTERPRISE,
    priceMonthly: null,
    priceYearly: null,
    features: [
      'Fully customizable, enterprise-grade setup',
      'Unlimited project & file size',
      'Unlimited files per project',
      'Custom integrations',
      'Custom server infrastructure setup',
      'Project retention after last access: customizable',
    ],
  },
];
